/* Keeps links/buttons inside slides that Horizon marks aria-hidden="true" (off-screen carousel
   cards, non-current gallery images) out of the Tab order, and restores them when the slide is
   shown again. Fixes the "ARIA hidden element must not be focusable" audit. Uses tabindex=-1, not
   inert, so a half-visible card at the carousel edge stays tappable. */
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, summary, iframe, [tabindex]:not([tabindex="-1"])';

  function sync(slide) {
    if (slide.getAttribute('aria-hidden') === 'true') {
      slide.querySelectorAll(FOCUSABLE).forEach(function (el) {
        if (el.hasAttribute('data-ptc-tabindex')) return;
        el.setAttribute('data-ptc-tabindex', el.getAttribute('tabindex') || '');
        el.setAttribute('tabindex', '-1');
      });
    } else {
      slide.querySelectorAll('[data-ptc-tabindex]').forEach(function (el) {
        var original = el.getAttribute('data-ptc-tabindex');
        el.removeAttribute('data-ptc-tabindex');
        if (original) el.setAttribute('tabindex', original);
        else el.removeAttribute('tabindex');
      });
    }
  }

  function syncWithin(root) {
    if (root.tagName === 'SLIDESHOW-SLIDE') sync(root);
    if (root.querySelectorAll) root.querySelectorAll('slideshow-slide').forEach(sync);
  }

  function init() {
    syncWithin(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes') {
          if (m.target.tagName === 'SLIDESHOW-SLIDE') sync(m.target);
        } else {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) syncWithin(n);
          });
        }
      });
    }).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
